var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['mc-status', 'mc-status--' + _vm.tone]},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},_vm._l((_vm.paths),function(d,i){return _c('path',{key:i,attrs:{"d":d}})}),0),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }